/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-07-28 10:21:37
 * @LastEditors: linxi
 * @LastEditTime: 2023-08-04 16:02:27
 */

import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  Modal,
  notification,
  Row,
  Table,
  Tabs,
} from 'antd'
import { use } from 'echarts'

const { TabPane } = Tabs
import React, { ReactElement, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../app/store'
import { getMonthYear } from '../../models/priceSetModal'
import { getPriceDetail, getPriceDetailSubmit } from './priceSetPageSclice'

export const PriceSetModal = (props: {
  selectedRowKeys?: any
  id?: any
  visible: boolean
  selectedRow: any
  onOk: () => void
  onCancel: () => void
}): ReactElement => {
  const [form] = Form.useForm()

  const dispatch = useDispatch<RootDispatch>()

  const [checkBoxValue, setCheckBoxValue] = useState<any>()

  const [dataList, setDataList] = useState<any>()

  const [yearList, setYearList] = useState<any>()

  const [detailList, setDetailList] = useState<any>()

  const [activeTab, setActiveTab] = useState('1')

  const [otherServiceData, setOtherServiceData] = useState([
    { name: '电子发票', productId: 7, actuallyPrice: '', checked: true },
    { name: 'VPN专线', productId: 23, actuallyPrice: '', checked: true },
    { name: '医保服务', productId: 25, actuallyPrice: '', checked: true },
  ])

  // 为每个其他服务创建多挡位价格数据
  const [otherServiceDetailData, setOtherServiceDetailData] = useState<any>({
    7: [], // 电子发票
    23: [], // VPN专线
    25: [], // 医保服务
  })

  // 为每个其他服务创建勾选状态
  const [otherServiceCheckBoxValue, setOtherServiceCheckBoxValue] = useState<any>({
    7: [], // 电子发票
    23: [], // VPN专线
    25: [], // 医保服务
  })

  const data = [
    {
      name:  '1年价格',
      year: 1,
    },
    {
      name:'2年价格',
      year: 2,
    },
    {
      name: '3年价格',
      year: 3,
    },
    {
      name: '4年价格',
      year: 4,
    },
    {
      name: '5年价格',
      year: 5,
    },
    {
      name: '6年价格',
      year: 6,
    },
    {
      name:  '7年价格',
      year: 7,
    },
    {
      name:  '8年价格',
      year: 8,
    },
    {
      name: '9年价格',
      year: 9,
    },
    {
      name:  '10年价格',
      year: 10,
    },
    {
      name: '终身价格',
      year: 99,
    },
  ]
  useEffect(() => {
    if (!props.visible) {
      form.resetFields()
      setDetailList([])
      setCheckBoxValue([])
      setDataList([])
    }
  }, [props.visible])

  useEffect(() => {
    if (props.visible) {
      if (props?.id)
        dispatch(getPriceDetail(props?.id))
          .then(unwrapResult)
          .then((v: any) => {
            setDetailList(v)
            // 只过滤出productId=1的记录用于系统价格选项卡
            const systemPriceData = v?.filter((i: any) => i?.productId == 1)
            setYearList(
              systemPriceData?.map((i: any) => {
                return i?.year
              })
            )
            setCheckBoxValue(
              systemPriceData?.map((i: any) => {
                return i?.year
              })
            )
          })
    }
  }, [props.visible, props?.id])

  console.log(
    props?.selectedRowKeys,
    props?.id,
    props?.id?.toString()?.split(),
    'props?.id'
  )

  useEffect(() => {
    if (props?.visible) {
      if (!props?.id) {
        setDataList(data)
        // 为每个其他服务初始化多挡位价格数据
        const initOtherServiceData: any = {}
        const initOtherServiceCheckBoxValue: any = {}
        otherServiceData?.forEach((service: any) => {
          initOtherServiceData[service?.productId] = data?.map((item: any) => {
            return {
              ...item,
              checked: false,
              actuallyPrice: '',
              discount: '',
            }
          })
          initOtherServiceCheckBoxValue[service?.productId] = []
        })
        setOtherServiceDetailData(initOtherServiceData)
        setOtherServiceCheckBoxValue(initOtherServiceCheckBoxValue)
      } else {
        console.log(yearList, 'yearList')
        setDataList(
          data?.map((value: any) => {
            return {
              ...value,
              checked: yearList?.includes(value?.year),
              actuallyPrice: detailList?.filter((i: any) => {
                return i?.year == value?.year && i?.productId == 1
              })?.[0]?.actuallyPrice,
              discount: detailList?.filter((i: any) => {
                return i?.year == value?.year && i?.productId == 1
              })?.[0]?.discount,
            }
          })
        )
        // 为每个其他服务初始化多挡位价格数据
        const initOtherServiceData: any = {}
        const initOtherServiceCheckBoxValue: any = {}
        otherServiceData?.forEach((service: any) => {
          initOtherServiceData[service?.productId] = data?.map((item: any) => {
            const serviceDetail = detailList?.filter((i: any) => {
              return i?.year == item?.year && i?.productId == service?.productId
            })?.[0]
            return {
              ...item,
              checked: serviceDetail ? true : false,
              actuallyPrice: serviceDetail?.actuallyPrice || '',
              discount: serviceDetail?.discount || '',
            }
          })
          initOtherServiceCheckBoxValue[service?.productId] = data?.filter((item: any) => {
            const serviceDetail = detailList?.filter((i: any) => {
              return i?.year == item?.year && i?.productId == service?.productId
            })?.[0]
            return serviceDetail ? true : false
          })?.map((item: any) => item?.year)
        })
        setOtherServiceDetailData(initOtherServiceData)
        setOtherServiceCheckBoxValue(initOtherServiceCheckBoxValue)
      }
    }
  }, [props?.visible, props?.id, detailList, yearList])

  // 保存函数（不关闭弹框）
  const handleSave = (closeModal = false) => {
    let params: any[] = []
    let priceRequired: any[] = []

    // 收集所有 tab 的勾选数据（而非仅当前激活 tab）
    // 1. 系统价格 (productId=1)
    const systemData = dataList?.filter((v: any) => v?.checked) || []
    const systemParams = systemData?.map((b: any) => ({
      actuallyPrice: b?.actuallyPrice,
      year: b?.year,
      discount: b?.discount ? b?.discount : undefined,
      tenantId: props?.id,
      productId: 1,
    }))
    params = [...params, ...systemParams]

    // 2. 其他服务价格 (productId=7, 23, 25)
    otherServiceData?.forEach((service: any) => {
      const serviceData =
        otherServiceDetailData?.[service?.productId]?.filter(
          (v: any) => v?.checked
        ) || []
      const serviceParams = serviceData?.map((b: any) => ({
        actuallyPrice: b?.actuallyPrice,
        year: b?.year,
        discount: b?.discount ? b?.discount : undefined,
        tenantId: props?.id,
        productId: service?.productId,
      }))
      params = [...params, ...serviceParams]
    })

    // 所有受管产品类型 ID，告诉后端需要全量替换这些类型的旧数据
    const allProductIds = [1, 7, 23, 25]

    const tenantIdList = props?.id
      ? props?.id?.toString()?.split()
      : props?.selectedRowKeys

    // 判断在勾选了的情况下价格有没有填写
    priceRequired = params
      ?.map((v: any) => {
        return v?.actuallyPrice ? v?.actuallyPrice : undefined
      })
      ?.filter((u: any) => u != undefined)

    if (priceRequired?.length == params?.length) {
      dispatch(
        getPriceDetailSubmit({
          tenantIdList: tenantIdList,
          tenantRenewalPriceItemList: params,
          allProductIds: allProductIds,
        })
      )
        .then(unwrapResult)
        .then((res) => {
          notification.success({ message: '保存成功' })
          if (closeModal) {
            props?.onOk()
          }
        })
    } else {
      notification.info({ message: '请输入必填项价格' })
    }
  }

  return (
    <div>
      <Modal
        width={700}
        destroyOnClose
        title={props?.id ? '修改价格' : '新增价格'}
        visible={props.visible}
        onCancel={() => props.onCancel()}
        footer={[
          <Button key='cancel' onClick={() => props.onCancel()}>
            取消
          </Button>,
          <Button key='save' type='primary' onClick={() => handleSave(false)}>
            保存
          </Button>,
          <Button key='saveAndClose' type='primary' onClick={() => handleSave(true)}>
            保存并关闭
          </Button>,
        ] as any}
      >
        <Tabs activeKey={activeTab} onChange={setActiveTab}>
          <TabPane tab='系统价格' key='1'>
            <div style={{ marginTop: '16px' }}>
              <Form
                form={form}
                labelCol={{ span: 3 }}
                wrapperCol={{ span: 16 }}
                autoComplete='off'
              >
            {/* <Form.Item
              name='price'
              label='单价'
              rules={[
                {
                  required: true,
                  pattern: /^([1-9][0-9]*)$/,
                  message: '请输入正整数',
                },
              ]}
            >
              <Input
                placeholder='请输入单价'
                // prefix={<SearchOutlined />}
                style={{ width: '315px' }}
              />
            </Form.Item> */}
            <Checkbox.Group
              value={checkBoxValue}
              style={{ width: '100%' }}
              onChange={(v) => {
                setCheckBoxValue(v)
                setDataList(
                  dataList?.map((value: any) => {
                    return {
                      ...value,
                      checked: v?.includes(value?.year),
                    }
                  })
                )
              }}
            >
              <Row>
                {dataList?.map((v: any) => {
                  return (
                    <>
                      <Col span={24}>
                        <Row style={{ height: '50px' }}>
                          <div style={{ width: '18%' }}>
                            <Checkbox value={v?.year}>
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                }}
                              >
                                <div
                                  style={{
                                    marginRight: '10px',
                                    marginLeft: '10px',
                                    width: '70px',
                                    marginTop: '4px',
                                    fontSize: '1rem',
                                  }}
                                >
                                  {v?.name}
                                </div>
                              </div>
                            </Checkbox>
                          </div>
                          <div style={{ width: '82%' }}>
                            <Form.Item required key={v?.year}>
                              {v?.checked && (
                                <Col>
                                  <Row wrap={false} align='middle'>
                                    <Col span={11}>
                                      <Form.Item
                                        rules={[
                                          {
                                            required: true,
                                            message: '价格不能为空',
                                          },
                                        ]}
                                      >
                                        <Input
                                          type='number'
                                          value={v?.actuallyPrice}
                                          placeholder='请输入价格'
                                          style={{ width: '160px' }}
                                          onChange={(e) => {
                                            setDataList(
                                              dataList?.map((value: any) => {
                                                return {
                                                  ...value,
                                                  actuallyPrice:
                                                    value?.year == v?.year
                                                      ? e?.target.value
                                                        ? Number(
                                                            e?.target.value
                                                          )
                                                        : ''
                                                      : value?.actuallyPrice,
                                                }
                                              })
                                            )
                                          }}
                                        />
                                      </Form.Item>
                                    </Col>
                                    <Col span={3}>
                                      <div
                                        style={{
                                          width: '50px',
                                          fontSize: '1rem',
                                          margin: '-20px  6px 0 6px',
                                        }}
                                      >
                                        元 ,
                                      </div>
                                    </Col>
                                    <Col span={11}>
                                      <Form.Item>
                                        <Input
                                          placeholder='请输入折扣/点击计算获取折扣'
                                          type='number'
                                          max={100}
                                          value={v?.discount}
                                          style={{ width: '160px' }}
                                          onChange={(e) => {
                                            setDataList(
                                              dataList?.map((value: any) => {
                                                return {
                                                  ...value,
                                                  discount:
                                                    value?.year == v?.year
                                                      ? e?.target.value
                                                        ? Number(
                                                            e?.target.value
                                                          )
                                                        : ''
                                                      : value?.discount,
                                                }
                                              })
                                            )
                                          }}
                                        />
                                      </Form.Item>
                                    </Col>
                                    <Col span={2}>
                                      <div
                                        style={{
                                          fontSize: '1rem',
                                          margin: '-20px  6px 0 6px',
                                        }}
                                      >
                                        折
                                      </div>
                                    </Col>
                                    <Col span={11}>
                                      <div
                                        style={{
                                          fontSize: '14px',
                                          margin: '-20px  6px 0 6px',
                                          color: '#027AFF ',
                                        }}
                                        onClick={() => {
                                          // 第一年的价格
                                          const oneYeayMoney = dataList?.filter(
                                            (v: any) => v?.year == 1
                                          )?.[0]?.actuallyPrice

                                          // 当前第几年的价格跟第一年的价格必须要有
                                          if (
                                            v?.actuallyPrice &&
                                            oneYeayMoney
                                          ) {
                                            // 计算折扣=x年价格/x/1年价格，如果1年价格没有时点击计算没反应，
                                            const discountValue =
                                              Number(v?.actuallyPrice) /
                                              Number(v?.year) /
                                              Number(oneYeayMoney)
                                            console.log(
                                              discountValue,
                                              'discountValue'
                                            )
                                            setDataList(
                                              dataList?.map((value: any) => {
                                                return {
                                                  ...value,
                                                  discount:
                                                    value?.year == v?.year
                                                      ? discountValue == 1
                                                        ? 1
                                                        : discountValue?.toFixed(
                                                            2
                                                          )
                                                      : value?.discount,
                                                }
                                              })
                                            )
                                          } else {
                                            // 没有的话点击无反应
                                          }
                                        }}
                                      >
                                        计算
                                      </div>
                                    </Col>
                                  </Row>
                                </Col>
                              )}
                            </Form.Item>
                          </div>
                        </Row>
                      </Col>
                    </>
                  )
                })}
              </Row>
            </Checkbox.Group>
            {/* <Row>
              <Col span={24}>
                <Form.Item label="时长：">
                  <span>1年</span>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item name='price' label="单价" rules={[
                  {
                    required: true,
                    pattern: /^([1-9][0-9]*)$/,
                    message: "请输入正整数",
                  },
                ]} getValueFromEvent={stringTrim}>
                  <Input
                    placeholder='请输入单价'
                    // prefix={<SearchOutlined />}
                    style={{ width: '315px' }}

                  />
                </Form.Item>
              </Col>
            </Row> */}
          </Form>
            </div>
          </TabPane>
          {/* 为每个其他服务创建一个选项卡 */}
          {otherServiceData?.map((service: any) => {
            return (
              <TabPane key={service?.productId} tab={service?.name}>
                <div style={{ marginTop: '16px' }}>
                  <Form
                    form={form}
                    labelCol={{ span: 3 }}
                    wrapperCol={{ span: 16 }}
                    autoComplete='off'
                  >
                    <Checkbox.Group
                      value={otherServiceCheckBoxValue?.[service?.productId]}
                      style={{ width: '100%' }}
                      onChange={(v) => {
                        const newCheckBoxValue = { ...otherServiceCheckBoxValue }
                        newCheckBoxValue[service?.productId] = v
                        setOtherServiceCheckBoxValue(newCheckBoxValue)
                        
                        const newDetailData = { ...otherServiceDetailData }
                        newDetailData[service?.productId] = newDetailData[service?.productId]?.map((value: any) => {
                          return {
                            ...value,
                            checked: v?.includes(value?.year),
                          }
                        })
                        setOtherServiceDetailData(newDetailData)
                      }}
                    >
                      <Row>
                        {otherServiceDetailData?.[service?.productId]?.map((v: any) => {
                          return (
                            <>
                              <Col span={24}>
                                <Row style={{ height: '50px' }}>
                                  <div style={{ width: '18%' }}>
                                    <Checkbox value={v?.year}>
                                      <div
                                        style={{
                                          display: 'flex',
                                          justifyContent: 'center',
                                        }}
                                      >
                                        <div
                                          style={{
                                            marginRight: '10px',
                                            marginLeft: '10px',
                                            width: '70px',
                                            marginTop: '4px',
                                            fontSize: '1rem',
                                          }}
                                        >
                                          {v?.name}
                                        </div>
                                      </div>
                                    </Checkbox>
                                  </div>
                                  <div style={{ width: '82%' }}>
                                    <Form.Item required key={v?.year}>
                                      {v?.checked && (
                                        <Col>
                                          <Row wrap={false} align='middle'>
                                            <Col span={11}>
                                              <Form.Item
                                                rules={[
                                                  {
                                                    required: true,
                                                    message: '价格不能为空',
                                                  },
                                                ]}
                                              >
                                                <Input
                                                  type='number'
                                                  value={v?.actuallyPrice}
                                                  placeholder='请输入价格'
                                                  style={{ width: '160px' }}
                                                  onChange={(e) => {
                                                    const newDetailData = { ...otherServiceDetailData }
                                                    newDetailData[service?.productId] = newDetailData[service?.productId]?.map((value: any) => {
                                                      return {
                                                        ...value,
                                                        actuallyPrice:
                                                          value?.year == v?.year
                                                            ? e?.target.value
                                                              ? Number(
                                                                  e?.target.value
                                                                )
                                                              : ''
                                                            : value?.actuallyPrice,
                                                      }
                                                    })
                                                    setOtherServiceDetailData(newDetailData)
                                                  }}
                                                />
                                              </Form.Item>
                                            </Col>
                                            <Col span={3}>
                                              <div
                                                style={{
                                                  width: '50px',
                                                  fontSize: '1rem',
                                                  margin: '-20px  6px 0 6px',
                                                }}
                                              >
                                                元 ,
                                              </div>
                                            </Col>
                                            <Col span={11}>
                                              <Form.Item>
                                                <Input
                                                  placeholder='请输入折扣/点击计算获取折扣'
                                                  type='number'
                                                  max={100}
                                                  value={v?.discount}
                                                  style={{ width: '160px' }}
                                                  onChange={(e) => {
                                                    const newDetailData = { ...otherServiceDetailData }
                                                    newDetailData[service?.productId] = newDetailData[service?.productId]?.map((value: any) => {
                                                      return {
                                                        ...value,
                                                        discount:
                                                          value?.year == v?.year
                                                            ? e?.target.value
                                                              ? Number(
                                                                  e?.target.value
                                                                )
                                                              : ''
                                                            : value?.discount,
                                                      }
                                                    })
                                                    setOtherServiceDetailData(newDetailData)
                                                  }}
                                                />
                                              </Form.Item>
                                            </Col>
                                            <Col span={2}>
                                              <div
                                                style={{
                                                  fontSize: '1rem',
                                                  margin: '-20px  6px 0 6px',
                                                }}
                                              >
                                                折
                                              </div>
                                            </Col>
                                            <Col span={11}>
                                              <div
                                                style={{
                                                  fontSize: '14px',
                                                  margin: '-20px  6px 0 6px',
                                                  color: '#027AFF ',
                                                }}
                                                onClick={() => {
                                                  // 第一年的价格
                                                  const oneYeayMoney = otherServiceDetailData?.[service?.productId]?.filter(
                                                    (v: any) => v?.year == 1
                                                  )?.[0]?.actuallyPrice

                                                  // 当前第几年的价格跟第一年的价格必须要有
                                                  if (
                                                    v?.actuallyPrice &&
                                                    oneYeayMoney
                                                  ) {
                                                    // 计算折扣=x年价格/x/1年价格，如果1年价格没有时点击计算没反应，
                                                    const discountValue =
                                                      Number(v?.actuallyPrice) /
                                                      Number(v?.year) /
                                                      Number(oneYeayMoney)
                                                    console.log(
                                                      discountValue,
                                                      'discountValue'
                                                    )
                                                    const newDetailData = { ...otherServiceDetailData }
                                                    newDetailData[service?.productId] = newDetailData[service?.productId]?.map((value: any) => {
                                                      return {
                                                        ...value,
                                                        discount:
                                                          value?.year == v?.year
                                                            ? discountValue == 1
                                                              ? 1
                                                              : discountValue?.toFixed(
                                                                  2
                                                                )
                                                            : value?.discount,
                                                      }
                                                    })
                                                    setOtherServiceDetailData(newDetailData)
                                                  } else {
                                                    // 没有的话点击无反应
                                                  }
                                                }}
                                              >
                                                计算
                                              </div>
                                            </Col>
                                          </Row>
                                        </Col>
                                      )}
                                    </Form.Item>
                                  </div>
                                </Row>
                              </Col>
                            </>
                          )
                        })}
                      </Row>
                    </Checkbox.Group>
                  </Form>
                </div>
              </TabPane>
            )
          })}
        </Tabs>
      </Modal>
    </div>
  )
}
